import { z } from 'zod';
import { baseEntitySchema, idSchema } from './common.js';
import { externalIdsSchema } from './projects.js';
/**
 * Bundles (TS-925 follow-up, 2026-11-02): hires a client bought together under one deal. A deal
 * holds any number of bundles beside its standalone jobs, and a job sits in at most one bundle
 * of its own client: any deal of the job's project (`jobs.bundleId`, decided 2026-11-03).
 *
 * **A slot is a hire.** `slotsPurchased` is how many the client paid for ("3VA" is 3);
 * `slotsUsed` is the bundle's filled positions, the sum of its live jobs' `filled`, so it is
 * counted, never typed. A replacement refills a position that is already filled, so it uses no
 * slot. `slotsUnused` never goes below 0; `slotsUsed` above `slotsPurchased` means the bundle was
 * overfilled.
 */
const slots = z.number().int().min(1).max(1_000);
const bundleFields = {
    name: z.string().trim().min(1).max(200),
    /** What was sold, as RecruitCRM's Hire Type names it ("3VA", "COR+3VA"…). */
    package: z.string().trim().max(60).nullable().optional(),
    slotsPurchased: slots,
    externalIds: externalIdsSchema.optional(),
};
/** `POST /deals/{id}/bundles`: the deal is the path's, the project is the deal's. */
export const bundleInputSchema = z.object(bundleFields);
/** Never the deal: a bundle belongs to its deal for life, like a job. */
export const bundlePatchSchema = z
    .object(bundleFields)
    .partial()
    .refine((p) => Object.keys(p).length > 0, { message: 'nothing to change' });
export const bundleSchema = baseEntitySchema.extend({
    dealId: idSchema,
    projectId: idSchema,
    name: z.string(),
    package: z.string().nullable(),
    slotsPurchased: z.number().int(),
    /** Filled positions across the bundle's live jobs. */
    slotsUsed: z.number().int(),
    /** `slotsPurchased − slotsUsed`, never below 0. */
    slotsUnused: z.number().int(),
    /** Live jobs in the bundle. */
    jobCount: z.number().int(),
    externalIds: externalIdsSchema,
});
//# sourceMappingURL=bundles.js.map